import { CooperationPartnerConfig } from '@app/icare/entities/cooperationPartner/config'
import { patientCooperationPartnerQueries } from '@app/icare/entities/cooperationPartner/queries/patientCooperationPartnerQueries'
import { PatientCooperationPartnerEditDrawer } from '@app/icare/entities/patient/edits/PatientCooperationPartnerEditDrawer'
import type { PatientCooperationPartnerRelation } from '@app/icare/entities/patient/schema/PatientCooperationPartner'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { RelationOverview } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationOverview'
import { isActivePatientRelation } from '@app/icare/shared/api/form.type'
import { entityParams } from '@pkg/db/utils'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useRelationCommitNavigation } from '../-components/useRelationCommitNavigation'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_cooperationPartner/kooperationspartner/')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    queryClient.ensureQueryData(patientCooperationPartnerQueries.forIndex(params.id)),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { data: cooperationPartners = [] } = useSuspenseQuery(patientCooperationPartnerQueries.forIndex(id))

  const navigate = Route.useNavigate()

  const handleAfterCommit = useRelationCommitNavigation<PatientCooperationPartnerRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/kooperationspartner/$relation',
        params: { id, relation: relation.id },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })
  return (
    <RelationOverview
      items={cooperationPartners}
      labels={CooperationPartnerConfig}
      findings={{}}
      basePath={`/patienten/${id}/kooperationspartner`}
      onEdit={params =>
        void PatientCooperationPartnerEditDrawer.show({ patientId: id, onAfterCommit: handleAfterCommit, ...params })
      }
    />
  )
}
